/**
 * Fixes a visual bug in the Editorial (media-with-content) section:
 * when the image column is set to stretch and match the text column's
 * height, opening/closing an accordion inside the text column animates
 * that column's height, which causes the grid to stretch the image
 * column in real time. Because the image uses object-fit: cover, this
 * reads as the image zooming in and out.
 *
 * Fix: lock the image column to a fixed pixel height on load (and on
 * resize), decoupling it from any later height changes caused by
 * accordion interactions.
 */
(function () {
  function lockMediaHeight(section) {
    var mediaBlock = section.querySelector('.media-block');
    var content = section.querySelector('.media-with-content__content');

    if (!mediaBlock || !content) return;

    function apply() {
      if (window.innerWidth < 750) {
        mediaBlock.style.removeProperty('height');
        return;
      }

      var height = content.getBoundingClientRect().height;

      if (height > 0) {
        mediaBlock.style.height = height + 'px';
      }
    }

    apply();

    var resizeTimeout;
    window.addEventListener('resize', function () {
      clearTimeout(resizeTimeout);
      resizeTimeout = setTimeout(apply, 150);
    });
  }

  function init() {
    document.querySelectorAll('.media-with-content').forEach(lockMediaHeight);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  // Re-apply when sections are re-rendered in the theme editor.
  document.addEventListener('shopify:section:load', function (event) {
    if (event.target && event.target.classList && event.target.classList.contains('shopify-section')) {
      var section = event.target.querySelector('.media-with-content');
      if (section) lockMediaHeight(section);
    }
  });
})();
